import React from 'react'

const Error = () => {
  return (
    <div>
      Error Page Comming Soon....
    </div>
  )
}

export default Error
